export default function GradientOverlay() {

  return (
    <>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'var(--hero-gradient)',
          opacity: 0.9
        }}
        aria-hidden="true"
      />

      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-10 pointer-events-none opacity-10 dark:opacity-10"
        style={{
          backgroundImage: 'url(/bg-pattern.jpg)'
        }}
        aria-hidden="true"
      />
    </>
  );
}
